import "./style.css";
import { startG3Telemetry } from "./g3-telemetry/index.js";

startG3Telemetry({
  ingestUrl: G3_INGEST_URL,
  reportToken: G3_REPORT_TOKEN,
  commit: G3_COMMIT_SHA,
  deployUrl: G3_DEPLOY_URL,
});

const h1 = document.createElement("h1");
h1.textContent = G3_PROJECT_NAME;
document.title = G3_PROJECT_NAME;
document.getElementById("app").append(h1);
